{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Включен",
      "DISABLED": "Изключен"
    },
    "CONFIGURE": "Настройка",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Потвърди изтриването",
        "ACCOUNT": "Прекъсване"
      },
      "MESSAGE": {
        "INBOX": "Are you sure to delete?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Да, изтрий",
        "ACCOUNT": "Да, прекъсни"
      },
      "CANCEL_BUTTON_TEXT": "Отмени",
      "API": {
        "SUCCESS_MESSAGE": "Успешно изтриване на куката",
        "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Входяща кутия",
      "EDIT": {
        "BUTTON_TEXT": "Редактирай"
      },
      "DELETE": {
        "BUTTON_TEXT": "Изтрий"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Създаване",
        "CANCEL": "Отмени"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
      }
    },
    "EDIT": {
      "TITLE": "Редактирай {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Изберете кутия",
          "PLACEHOLDER": "Изберете кутия"
        },
        "SUBMIT": "Обнови",
        "CANCEL": "Отказ"
      },
      "API": {
        "SUCCESS_MESSAGE": "Интеграционният hook е обновен успешно",
        "ERROR_MESSAGE": "Не можахме да се свържем с чат сървъра, моля опитайте по-късно"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Прекъсване"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Синхронизирайте имейли и уеб-чатове с вашия daktela акаунт.",
      "RETINO": "Retino въвежда ред в управлението на връщания и рекламации.",
      "MAILSHIP": "Mailship е система за управление на склад и изпълнение на поръчки. Проверявайте статус на поръчки, проследяване и подробности за експедицията.",
      "RAYNET": "Свържете своя акаунт в Raynet CRM, за да получите достъп до данните на клиентите си. Добавете връзка с потребителското си име и API токен за Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Тест на връзката",
      "SUCCESS": "Успешна връзка",
      "ERROR": "Връзката е неуспешна. Моля, проверете данните си за вход."
    }
  }
}
